export default {
  teamMembers: {
    items: [],
    count: 0,
    isLoaded: false,
  },
  error: null,
}
